module.exports = __webpack_public_path__ + "static/media/client5.966d55fa.svg";